import {
  Autocomplete,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useId, useState } from "react";
import { parsePnrInput } from "./services";
import "./index.scss";
import { MedphotoContext } from "medphoto.context";
import { AuthenticationContext } from "medtankengroup-authentication/context";

export const PatientPnrPage = ({ onEnter }: { onEnter: (pnr: string) => void }) => {
  const { units, selectUnit, selectedUnitOption } = useContext(MedphotoContext);
  const [patientPnr, setPatientPnr] = useState({ value: "", valid: false });
  const pnrId = useId();
  const { user, doLogout } = useContext(AuthenticationContext);

  function handlePatientPnrInput(newValue: string) {
    const oldValue = patientPnr.value;
    const { value, valid } = parsePnrInput(newValue, oldValue);
    setPatientPnr((ps) => ({ ...ps, value: value, valid }));
  }
  return (
    <div className="pnr-input-page">
      <div className="pnr-entry-box">
        <span>
          Inloggad som {`${user.first_name} ${user.last_name}. `}
          <Button variant="outlined" size="small" onClick={doLogout}>
            Logga ut
          </Button>
        </span>
        <div>
          <Autocomplete
            fullWidth
            renderInput={(params) => <TextField variant="outlined" {...params} label="Välj enhet" />}
            options={units.map((unit) => ({ id: unit.id, label: unit.name }))}
            onChange={(_, value) => selectUnit(value)}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            value={selectedUnitOption}
          />
          <Typography color="error">
            På grund av tekniska problem går det för närvarande inte att skicka in filer till Webdoc.
          </Typography>
        </div>
        <FormControl
          style={{ width: "100%" }}
          variant="outlined"
          error={patientPnr.value.length > 8 && !patientPnr.valid}
        >
          <InputLabel htmlFor={pnrId + "-pnr"}>Patientens Personnummer</InputLabel>
          <OutlinedInput
            id={pnrId + "-pnr"}
            type="tel"
            value={patientPnr.value}
            onChange={(e) => handlePatientPnrInput(e.target.value)}
            label="Patientens Personnummer"
            fullWidth
          />
          {patientPnr.value.length > 8 && !patientPnr.valid && (
            <FormHelperText id="patient-ombud-pnr-error">Personnummret är ej giltigt</FormHelperText>
          )}
        </FormControl>
        <Button
          variant="contained"
          fullWidth
          disabled={!patientPnr.valid || !selectedUnitOption}
          onClick={() => onEnter(patientPnr.value)}
        >
          Gå vidare
        </Button>
      </div>
    </div>
  );
};
